import { Wrench, Database, LayoutGrid, Globe } from "lucide-react";

const items = [
  { icon: Database, label: "Migration de tes données existantes" },
  { icon: LayoutGrid, label: "Plan de salle, horaires, créneaux" },
  { icon: Globe, label: "Widget de réservation sur ton site" },
];

const ActivationOption = () => {
  return (
    <section className="py-16 bg-primary text-primary-foreground">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <div className="flex items-center justify-between flex-wrap gap-4 mb-6 pb-6 border-b border-primary-foreground/20">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-full bg-primary-foreground/10 flex items-center justify-center flex-shrink-0">
                <Wrench className="w-6 h-6 text-primary-foreground" />
              </div>
              <div>
                <h2 className="font-playfair text-2xl md:text-3xl font-bold mb-1">
                  Accompagnement optionnel
                </h2>
                <p className="text-sm opacity-80 italic">
                  Configure toi-même ou fais-toi accompagner
                </p>
              </div>
            </div>
            <div className="text-right">
              <p className="font-playfair text-3xl font-bold">100 CHF</p>
              <p className="text-xs opacity-80">une seule fois</p>
            </div>
          </div>

          <p className="text-sm md:text-base leading-relaxed opacity-90 mb-6">
            L'application est conçue pour être configurable par toi-même. Si tu préfères gagner du temps, on s'occupe de tout à ta place pour 100 CHF. À solliciter depuis ton dashboard une fois ton compte créé, remboursable si tu ne poursuis pas.
          </p>

          <ul className="space-y-3">
            {items.map((item) => {
              const Icon = item.icon;
              return (
                <li key={item.label} className="flex items-center gap-3">
                  <Icon className="w-5 h-5 opacity-70 flex-shrink-0" />
                  <span className="text-sm md:text-base">{item.label}</span>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default ActivationOption;
